import React from "react";
import classNames from "classnames/bind";

import { ScreenInfo } from "../../components/ScreenInfo";
import { Button } from "../../components/Button";
import { WelcomeCarousel } from "../../components/WelcomeCarousel";

import { useStateManager } from "utils/useStateManager";
import { UserType } from "types/UserType";

import styles from "./Welcome.module.css";

const cx = classNames.bind(styles);

type Props = {
  onSubmit: (exists?: boolean) => void;
};

const labelByType = {
  [UserType.LITE]: "консультант",
  [UserType.PRO]: "врач",
};

const carouselType = {
  DIETANAMNEZ: "WELCOME_DIETANAMNEZ",
  REGISTRATION: "WELCOME_REGISTRY",
} as const;

export const Welcome: React.FC<Props> = (props) => {
  const { linkInfo, userType, type, dietanamnez , tokenRegistration} = useStateManager();
  const isEpharmacy = linkInfo?.custom?.custom_генерировать_бад_рацион_при_саморегистрации;

  if (!localStorage.getItem(`self_registration_id_${tokenRegistration}`) && !localStorage.getItem('self_registration_id') && tokenRegistration) {
    localStorage.setItem(`self_registration_id_${tokenRegistration}`, `${new Date().valueOf()}`);
  }

  return (
    <ScreenInfo
      icon={type === "REGISTRATION" ? null : undefined}
      title={
        linkInfo?.userName ? (
          <>
            Здравствуйте, <br /> {linkInfo?.userName}!
          </>
        ) : (
          "Здравствуйте!"
        )
      }
    >
      <p className={cx("info")}>
        {type === "REGISTRATION" ? (
          <span>
            <span style={{ marginBottom: "10px", display: "block" }}>
              {linkInfo?.authorName} приглашает оценить сбалансированность
              вашего фактического питания.
            </span>
            {!isEpharmacy &&
              <>
                <br />
                <span>
                  Если приглашение отправлено Вам ошибочно, просто проигнорируйте его.
                </span>
              </>
            }
          </span>
        ) : (
          `Ваш ${labelByType[userType]} ${linkInfo?.authorName} приглашает вас пройти опрос по фактическому питанию`
        )}
      </p>

      <WelcomeCarousel
        userType={userType}
        dietanamnezType={dietanamnez?.custom_тип_да!}
        carouselType={carouselType[type]}
      />

      <div className={cx("actions")}>
        <Button
          color="white"
          block
          size="medium"
          rounded
          type="button"
          onClick={() => props.onSubmit()}
        >
          Начать
        </Button>
      </div>
    </ScreenInfo>
  );
};
